

const frfr_lib_changes_id = '/FRFR/frfr-frontend-db.js/changes_id2025-03-17r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-js-utils // JavaScript UTILS
Version ID: 1a 2025-03-17r1
by 
// Please describe here if you customized this file
*/


const js_utils = {};

// ---- detect

js_utils.is_null = function (n) {
  if (n === null) {
    return true;
  }
  return false;
};

js_utils.is_number = function (n) {
  // let n = Number.parseFloat(_n); 
  if (!isNaN(n)) { // undefined n also return 
    // use type coercion to parse the _entirety_ of the string (`Number.parseFloat` alone does not do this)...
    if (!isNaN(Number.parseFloat(n))) {
      // ...and ensure strings of whitespace fail
      return true;
    }
  }
  return false;
};

js_utils.is_number_greater_than_number2 = function (n, n2) {
  if (js_utils.is_number(n) && js_utils.is_number(n2) && n > n2) {
    return true;
  }
  return false;
};

js_utils.is_number_greater_than_or_equal_number2 = function (n, n2) {
  if (js_utils.is_number(n) && js_utils.is_number(n2) && (n > n2 || n === n2)) {
    return true;
  }
  return false;
};


js_utils.is_number_less_than_number2 = function (n, n2) {
  if (js_utils.is_number(n) && js_utils.is_number(n2) && n < n2) {
    return true;
  }
  return false;
};

js_utils.is_number_less_than_or_equal_number2 = function (n, n2) {
  if (js_utils.is_number(n) && js_utils.is_number(n2) && (n < n2 || n === n2)) {
    return true;
  }
  return false;
};

js_utils.is_number_zero_or_greater = function (n) {
  if (n === 0 || n > 0) {
    return true;
  }
  return false;
};


js_utils.is_string = function (str) {
  if (typeof str === 'string') {
    return true;
  }
  return false;
};

js_utils.is_string_not_empty = function (x) {
  if ((js_utils.is_string(x) && x !== '')) {
    return true;
  }
  return false;
};

js_utils.is_number_or_string = function (x) {
  if (js_utils.is_number(x) || (js_utils.is_string(x))) {
    return true;
  }
  return false;
};

js_utils.is_number_or_string_not_empty = function (x) {
  if (js_utils.is_number(x) || (js_utils.is_string(x) && x !== '')) {
    return true;
  }
  return false;
};

js_utils.is_object = function (obj) {
  if (typeof obj === 'object' && obj !== null && !Array.isArray(obj)) {
    return true;
  }
  return false;
};

js_utils.is_array = function (arr) {
  if (Array.isArray(arr)) {
    return true;
  }
  return false;
};

js_utils.is_object_empty = (value) => {
  // https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object

  if (value == null) {
    // null or undefined
    return false;
  }

  if (typeof value !== 'object') {
    // boolean, number, string, function, etc.
    return false;
  }

  const proto = Object.getPrototypeOf(value);

  // consider `Object.create(null)`, commonly used as a safe map
  // before `Map` support, an empty object as well as `{}`
  if (proto !== null && proto !== Object.prototype) {
    return false;
  }

  for (const prop in value) {
    if (Object.hasOwn(value, prop)) {
      return false;
    }
  }
  return true;
};


// ----- comparison


//
const _get_comparison_weight = (x) => {
  let weight = 0; // comparison primary weight
  if (typeof x === 'undefined') {
    weight = 1;
  } else if (x === null) {
    weight = 2;
  } else if (Array.isArray(x)) {
    weight = 4;
  } else if (js_utils.is_object(x)) {
    weight = 5;
  } else if (typeof x === 'boolean') {
    weight = 7;
  } else if (typeof x === 'number') {
    if (Number.isNaN(x)) {
      weight = 6; //
    } else {
      weight = 8;
    }
  } else if (typeof x === 'string') {
    weight = 9;
  } else {
    weight = 3;
  }
  return weight;
};
js_utils.compare_a_b_smart = (a, b) => {
  // return -1, 1 or 0
  const _a_w = _get_comparison_weight(a);
  const _b_w = _get_comparison_weight(b);
  if (_a_w === _b_w) { // CASE equal primary comparison weight
    // STANDARD COMPARISON
    /*
    // ascending
    if (a[sortedCellKey] < b[sortedCellKey]) {
      order = -1;
      // return -1;
    }
    */
    if (a < b) {
      return -1; // ascending
    }
    if (a > b) {
      return 1; // ascending
    }
    // a must be equal to b
    return 0;
  } else { // CASE different primary comparison weight
    if (_a_w < _b_w) {
      return -1; // ascending
    } else {
      return 1; // ascending
    }
  }
  return 0; // not possible
};


js_utils.compare_shallow_objects = (obj1, obj2) => {
  // NOVO
  // only comparing 1 level of properties
  // This is also known as a field-by-field compare
  let is_equal = true;
  // let test = true;
  /*
  // SLOW COMPARISON
  Object.keys(obj1).forEach((key) => {
    if (obj1[key] !== obj2[key]) {
      test = false;
    }
  });
  Object.keys(obj2).forEach((key) => {
    if (obj1[key] !== obj2[key]) {
      test = false;
    }
  });
  */
  /*
  // OPTIMIZED COMPARISON
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  let i = 0;
  let ii = 0;
  let key;
  while (test === true && ii < keys2.length) {
    if (i < keys1.length) {
      // first object keys
      key = keys1[i];
      if (obj1[key] !== obj2[key]) {
        test = false;
      }
      i++;
    } else {
      // second object keys
      key = keys2[ii];
      if (obj1[key] !== obj2[key]) {
        test = false;
      }
      ii++
    }
  }
  */
  // OPTIMIZED COMPARISON v2023
  /*
  // https://stackoverflow.com/questions/22266826/how-can-i-do-a-shallow-comparison-of-the-properties-of-two-objects-with-javascri
  const shallowCompare = (obj1, obj2) =>
    Object.keys(obj1).length === Object.keys(obj2).length &&
    Object.keys(obj1).every(key =>
      obj2.hasOwnProperty(key) && obj1[key] === obj2[key]
    );
  */
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);
  if (keys1.length === keys2.length) {
    // same length of keys
    if (keys1.length === 0) {
      // both object empty. {} === {}
      is_equal = true;
      return is_equal;
    }
    // comparing every property
    let i = 0;
    let key;
    while (is_equal === true && i < keys1.length) {
      key = keys1[i];
      if (obj2.hasOwnProperty(key)) {
        if (obj1[key] === obj2[key]) {
          // do nothing
        } else {
          // oba propertija postoje ali nisu isti
          // console.log('obj1[key] === obj2[key] failed', key);
          is_equal = false;
        }
      } else {
        // obj2 uopste nema taj properti. To sprecava slucaj kada je obj[key] undefined a obj2[key] ne postoji i onda je undefined zato sto uopste nema taj properti pa bi se desilo da su oba undefined i da su zbog toga isti.
        // console.log('obj2.hasOwnProperty(key) failed', key);
        is_equal = false;
      }
      i++;
    } // end of while
  } else {
    // not same length of keys
    // console.log('not same length of key');
    is_equal = false;
  }
  // console.log(equal);
  return is_equal;
};

js_utils.compare_objects = function (obj1, obj2, ignore_keys) {
  // only comparing 1 level of properties, always ignore nested objects
  let test = true;
  // console.log('* obj1, obj2');
  const _key_not_ignored = (key) => {
    let not_ignored = true;
    let _ignore_keys = [];
    if (Array.isArray(ignore_keys)) {
      _ignore_keys = ignore_keys;
    }
    _ignore_keys.forEach((ik) => {
      if (key === ik) {
        not_ignored = false;
      }
    });
    return not_ignored;
  };
  Object.keys(obj1).forEach((key) => {
    if (_key_not_ignored(key) && !js_utils.is_object(obj1[key]) && !js_utils.is_object(obj2[key])) {
      // console.log(key, obj1[key], obj2[key]);
      if (obj1[key] !== obj2[key]) {
        test = false;
      }
    }
  });
  Object.keys(obj2).forEach((key) => {
    if (_key_not_ignored(key) && !js_utils.is_object(obj1[key]) && !js_utils.is_object(obj2[key])) {
      if (obj1[key] !== obj2[key]) {
        test = false;
      }
    }
  });
  // console.log(test);
  return test;
};

js_utils.compare_array_of_objects = (arr1, arr2, ...ignore_key) => {
  // console.log(' AAAA compare_array_of_objects(arr1, arr2)');
  // console.log(arr1);
  // console.log(arr2);
  // COMPARE ONLY ONE LEVEL OF PROPERTIES
  if (arr1.length !== arr2.length) {
    return false;
  }
  let test = true;
  arr1.forEach((a, index) => {
    if (!js_utils.compare_objects(a, arr2[index], ignore_key)) { // NEGACIJA
      test = false;
    }
  });
  // console.log(test);
  return test;
};

js_utils.compare_arrays_of_values = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }
  let test = true;
  arr1.forEach((a, index) => {
    if (a !== arr2[index]) {
      test = false;
    }
  });
  return test;
};

js_utils.pure_clone_by_json = (obj) => {
  // WARNING
  // Note that JSON method will loose any Javascript types that have no equivalent in JSON. For example: JSON.parse(JSON.stringify({a:null,b:NaN,c:Infinity,d:undefined,e:function(){},f:Number,g:false})) will generate {a: null, b: null, c: null, g: false}
  return JSON.parse(JSON.stringify(obj));
};

js_utils.clone_obj_but_only_selected_keys = (obj, selected_keys_arr = []) => {
  let new_obj = {};
  let _selected_keys_arr = [];
  if (Array.isArray(selected_keys_arr)) {
    _selected_keys_arr = selected_keys_arr;
  }
  _selected_keys_arr.forEach((key) => {
    if (key in obj) {
      new_obj[key] = obj[key];
    }
  });
  return new_obj;
};

js_utils.clone_obj_but_without_selected_keys = (obj, selected_keys_arr = []) => {
  let new_obj = {};
  let _selected_keys_arr = [];
  if (Array.isArray(selected_keys_arr)) {
    _selected_keys_arr = selected_keys_arr;
  }
  Object.keys(obj).forEach((key) => {
    if (_selected_keys_arr.includes(key)) {
      // skip
    } else {
      new_obj[key] = obj[key];
    }
  });
  return new_obj;
};


// ----- other


js_utils.string_trim_smart = (x) => { // TODO
  if (typeof x === 'string') {
    return x.trim();
  }
  return x;
};


js_utils.convert_object_to_array = (obj) => {
  let arr = [];
  for (const [key, value] of Object.entries(obj)) {
    // // console.log(`${key}: ${value}`);
    arr.push({
      key: key,
      value: value
    })
  }
  return arr;
};


js_utils.dirty_enrich_object_with_obj2_shallow = (obj_ref, obj2) => {
  if (js_utils.is_object(obj_ref) && js_utils.is_object(obj2)) { // enrich only if both are objects
    Object.keys(obj2).forEach((key) => {
      // shallow
      obj_ref[key] = obj2[key];
    });
    return obj_ref;
  } else {
    // return unchanged
    return obj_ref;
  }
};


js_utils.array_of_arrays_all_keys = (arr) => {
  // AOA Array Of Arrays
  // also works on Array of Objects
  const keys = [];
  let _keys;
  arr.forEach((item) => {
    _keys = Object.keys(item); // also indexes of array
    _keys.forEach((key) => {
      if (keys.includes(key)) {
        // do nothing
      } else {
        keys.push(key);
      }
    });
  });
  return keys;
};


export { js_utils };
// exports.js_utils = js_utils; // Node.js named export